/**
 * Zelle QR `data=` payload helpers. Official samples use contiguous digits for
 * mobile tokens (no dashes) and ordered keys: name, action, token.
 */

export function normalizeZelleToken(raw) {
  const t = String(raw || "").trim();
  if (!t) return "";

  // Email enrollment
  if (t.includes("@")) {
    return t.replace(/\s/g, "").toLowerCase();
  }

  const digitsOnly = t.replace(/\D/g, "");
  // US/mobile-style numbers — Zelle QR uses digits only (e.g. 2135099817 not 213-509-9817).
  // +1 prefixes become 11 digits; Zelle payloads use the 10-digit national number (see Early Warning samples).
  if (digitsOnly.length >= 10) {
    if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
      return digitsOnly.slice(1);
    }
    return digitsOnly;
  }

  return t;
}

/** Remove all spaces; fallback to "NA" if name is empty. */
export function normalizeZelleRecipientName(raw) {
  const noSpaces = String(raw || "").replace(/\s+/g, "").trim();
  return noSpaces || "NA";
}

/**
 * Canonical JSON matching Zelle app QR payloads (key order preserved by JSON.stringify insertion order).
 */
export function buildZellePaymentPayloadJson({ token, name }) {
  const cleanToken = normalizeZelleToken(token);
  const cleanName = normalizeZelleRecipientName(name);
  if (!cleanToken) return "";

  const obj = {
    name: cleanName,
    action: "payment",
    token: cleanToken,
  };

  return JSON.stringify(obj);
}
